export enum ESplineHologramBuildStep {
  SHBS_FindStart,
  SHBS_PlacePoleOrSnapEnding,
  SHBS_AdjustPole,
}
